import DateFormat from '@/Enums/Format/DateFormat.enum';
import { useAppSelector } from '@/store/hooks';
import moment from 'moment';
import { FC } from 'react';

const DataAgreementContent: FC = () => {
  const { firstName, lastName } = useAppSelector(state => state.me.userProfile);
  const { whitelabelName } = useAppSelector(state => state.currentWhitelabel.whitelabel);

  return (
    <div>
      <h2 className='font-semibold text-[24px]'>Data Agreement</h2>
      <hr className='-mx-[30px] my-2' />
      <div className='p-2'>
        <p className='mb-4'>
          <strong>Data Upload and Compliance Agreement:</strong> By uploading any personally identifiable information
          (“PII”) of any natural person (a “First Party User”) onto the <span>{whitelabelName}</span> Platform (the
          "Platform"), the Advertiser and any of its agents making such upload, in partial consideration of their use of
          the Platform and related services, agree to and confirm the following:
        </p>
        <ol className='list-decimal list-inside pl-5 space-y-4'>
          <li>
            <strong>Geographical Limitation:</strong> The Advertiser and any such agent warrant that all uploaded PII
            relates exclusively to First Party Users who, at the time the PII was collected, were located within the
            United States.
          </li>
          <li>
            <strong>Legal Acquisition of Data:</strong> The Advertiser and any such agent affirm that all uploaded PII
            has been lawfully acquired in accordance with applicable privacy and data protection laws. The Advertiser
            and any such agent further confirm that it holds all necessary consents, permissions, or legal bases
            required to collect, store, and use the PII for the purpose of obtaining the services for which it is
            uploaded.
          </li>
          <li>
            <strong>Data Security Commitment:</strong> The Advertiser and any such agent acknowledge that the upload of
            PII through the Platform is not to any server or system of <span>{whitelabelName}</span> Media, Inc. but is
            instead to the systems of, and for services provided by, VisitIQ, LLC (hereinafter referred to as "
            VisitIQ"); and that upon processing of that PII by VisitIQ, it will be returned to{' '}
            <span>{whitelabelName}</span> Media, Inc. in anonymized form. VisitIQ is under contractual obligation to{' '}
            <span>{whitelabelName}</span> Media, Inc. not to use the PII for any purpose other than providing the
            services requested by <span>{whitelabelName}</span> Media, Inc. on behalf of the Advertiser and not to
            retain the PII after completion of those services. While <span>{whitelabelName}</span> Media, Inc., in
            connection with the Platform and with the storage and use of the anonymized information returned to it, will
            employ commercially reasonable technical, administrative, and physical safeguards to protect the security,
            integrity, and confidentiality of the PII and the anonymized data, the Advertiser and any such agent
            acknowledge that no system can fully guarantee the security of data. The <span>{whitelabelName}</span>{' '}
            Media, Inc and the Platform disclaim any liability for unauthorized access, breach, or misuse of data,
            except where caused by their gross negligence or willful misconduct. VisitIQ is unaffiliated with{' '}
            <span>{whitelabelName}</span> Media, Inc. The privacy policy of VisitIQ is available at{' '}
            <a
              href='https://visitiq.io/wp-content/uploads/2025/07/VisitIQ-Privacy-Policy-July-2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-500 underline'
            >
              https://visitiq.io/wp-content/uploads/2025/07/VisitIQ-Privacy-Policy-July-2025.pdf
            </a>
            .
          </li>
        </ol>

        <p className='my-4'>
          By proceeding with the upload of any user data, the Advertiser and any such agent acknowledge and agree to the
          terms stated in this Agreement as an integral and necessary part of the consideration for, and as a required
          condition of, their use of the Platform.
        </p>
      </div>
      <h3 className='text-[24px]'>{`${firstName} ${lastName}`}</h3>
      <p className='text-[#84818A] font-medium'>{moment(new Date()).format(DateFormat.DayLongMonthYear)}</p>
      <hr className='my-4' />
    </div>
  );
};

export default DataAgreementContent;
